import React from "react";
import {Dictionary} from "../../components/Dictionary";
import {RightAside} from "../../components/Aside/RightAside";
import {PlusCircleFill, SignTurnRightFill} from "react-bootstrap-icons";
import {FormSubmit} from "../../components/FormComponent/FormSubmit";
import {Util} from "../../components/Util";
import {FormComponent} from "../../components/FormComponent";
import {FormGroup} from "../../components/FormComponent/FormGroup";
import {TBody} from "../../components/Table/TBody";
import Input from "../../components/FormComponent/FormGroup/Input";

export class OrderScheduleCreate extends FormComponent {
    protected dictionary: Dictionary = new Dictionary();

    protected handleSubmit(event: any) {
        super.handleSubmit(event);
    }

    protected onSuccess(data: any, event: React.FormEvent | null): any {
        if (data.message) {
            (
                document.querySelector('form .alert.alert-success') as HTMLElement
            ).innerHTML = this.dictionary.get[data.message];
        }
        (
            document.querySelector('form .alert.alert-success') as HTMLElement
        ).classList.remove('hide');
    }

    render() {
        const now = new Date();
        return (
            <div className="hidden">
                <form onSubmit={this.handleSubmit} action={'/order-schedule'} method="POST" id="create-details"
                      className="hidden details">

                    <h6>
                        {this.dictionary.get['create-order-schedule']}
                        <SignTurnRightFill className="closeRightAside" onClick={RightAside.close}/>
                    </h6>

                    <div className="table-responsive">
                        <table className="table table-sm align-middle inlineTable">
                            <tbody>
                            <tr>
                                <td>{this.dictionary.get['service-provider']}</td>
                                <td>
                                    <FormGroup.Select {...{
                                        id: 'service_id',
                                        required: true,
                                        skipLabel: true,
                                        items: this.props.services
                                    }}/>
                                </td>
                            </tr>
                            <tr>
                                <td>{this.dictionary.get['type']}</td>
                                <td>
                                    <FormGroup.Select {...{
                                        id: 'type',
                                        required: true,
                                        skipLabel: true,
                                        items: ['via-sku']
                                    }}/>
                                </td>
                            </tr>
                            <tr>
                                <td>{this.dictionary.get['schedule_start']}</td>
                                <td>
                                    <FormGroup.DateTime {...{
                                        id: 'schedule_start',
                                        required: true,
                                        skipLabel: true,
                                        defaultValue: Util.formatDate(now).substring(0, 10) + ' 00:00:00'
                                    }}/>
                                </td>
                            </tr>
                            <tr>
                                <td>{this.dictionary.get['schedule_end']}</td>
                                <td>
                                    <FormGroup.DateTime {...{
                                        id: 'schedule_end',
                                        required: true,
                                        skipLabel: true,
                                        defaultValue: Util.formatDate(now.setDate(now.getDate() + 7)).substring(0, 10) + ' 00:00:00'
                                    }}/>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <h6>
                        {this.dictionary.get['items']}
                    </h6>

                    <div className="table-responsive">
                        <table className="table table-sm align-middle inlineTable">
                            <thead>
                            <tr>
                                <th colSpan={2}>{this.dictionary.get['sku']}</th>
                                <th>&nbsp;</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr key={'rowI' + TBody.index++} className="newItem">
                                <td colSpan={2}><Input id={'sku-input'} skipLabel={true}
                                                       placeholder={this.dictionary.get['sku']}/></td>
                                <td><PlusCircleFill onClick={this.addSKU} className="addIcon"/></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <FormSubmit aside={true}/>
                </form>
            </div>
        );
    }

    protected removeSKU(e: any): void {
        e.preventDefault();
        const tr = e.target.closest('tr');
        if (tr) {
            tr.remove();
        }
    }

    protected addSKU(e: any): void {
        e.preventDefault();
        const tr = e.target.closest('tr');
        if (!tr) {
            console.error('Can not find closest tr element.')
            return;
        }

        const newInput: HTMLInputElement = tr.querySelector('input');
        const inputValue = newInput.value;

        if (inputValue === "0" || inputValue === "") {
            return;
        }

        let newLine: HTMLElement = document.createElement("tr"),
            input: HTMLElement = document.createElement("input"),
            col1: HTMLElement = document.createElement("td"),
            col2: HTMLElement = document.createElement("td");

        // <input type="hidden" name="product_category[]" value={item.id}/>
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', 'sku[]');
        input.setAttribute('value', inputValue);

        newLine.append(col1, col2);

        col1.textContent = inputValue;
        col1.append(input);
        col1.setAttribute("colspan", "2");
        col2.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" fill="currentColor" class="bi bi-x-circle-fill removeIcon"><path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z"></path></svg>';

        let parent = tr.parentNode;

        parent.insertBefore(newLine, tr);

        (col2.children[0] as HTMLElement).addEventListener("click", function (e: any) {
            e.preventDefault();
            const tr = e.target.closest('tr');
            if (tr) {
                tr.remove();
            }
        });

        newInput.value = '';
    }
}
